type ElementName = "button" | "icon";
type StyleName = "primary" | "disabled" | "secondary";

interface ClassNames {
  [key: string]: {
    [key: string]: string;
  };
}

/**
 *
 * @param element Type of the element that we want to get a classname from
 * @param style Depending on the style the element will have a different classname
 * @returns a tailwind classname that to apply on a element (for now it's only for colors)
 */

export default function getClassName(element: ElementName, style: StyleName = "primary"):string{
  const classNames: ClassNames = {
    button: {
      primary: "bg-[color:var(--primaryColor)] text-[color:var(--secondaryColor)]",
      disabled: "bg-[#d8d8dc] text-white",
      secondary: "bg-[color:var(--secondaryColor)] text-[color:var(--primaryColor)]"
    },
    icon: {
      primary: "stroke-[color:var(--primaryColor)] fill-[color:var(--secondaryColor)]",
      secondary: "stroke-[color:var(--secondaryColor)] fill-[color:var(--primaryColor)]"
    },
  };

  return classNames[element]?.[style] || "";
}
